import React from 'react';

type ViewActionIconProps = {
  className?: string;
};

export default function ViewActionIcon({ className }: ViewActionIconProps) {
  return (
    <svg
      className={className}
      width="18"
      height="16"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <g clipPath="url(#clip0_519_23929)">
        <path
          d="M11.3747 16.2322C11.3191 16.0826 11.3191 15.9179 11.3747 15.7682C11.9158 14.4561 12.8344 13.3343 14.0139 12.5448C15.1934 11.7554 16.5807 11.334 18 11.334C19.4193 11.334 20.8067 11.7554 21.9862 12.5448C23.1657 13.3343 24.0842 14.4561 24.6253 15.7682C24.6809 15.9179 24.6809 16.0826 24.6253 16.2322C24.0842 17.5443 23.1657 18.6662 21.9862 19.4556C20.8067 20.2451 19.4193 20.6665 18 20.6665C16.5807 20.6665 15.1934 20.2451 14.0139 19.4556C12.8344 18.6662 11.9158 17.5443 11.3747 16.2322Z"
          stroke="#213F39"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14C16.8954 14 16 14.8954 16 16C16 17.1046 16.8954 18 18 18Z"
          stroke="#213F39"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_519_23929">
          <rect width="16" height="16" fill="white" transform="translate(10 8)" />
        </clipPath>
      </defs>
    </svg>
  );
}
